<template>
  <div class="item columns" v-if="isLeft">
    <div class="column">
      <img
        class="item-left"
        style="height: 200px"
        :src="getImageUrl(image)"
        alt="Image"
      />
    </div>

    <div class="column">
      <Description
        :title="title"
        :vendor="vendor"
        :messages="messages"
        class="item-left"
      ></Description>
    </div>
  </div>

  <div class="item columns" v-else>
    <div class="column">
      <Description
        :title="title"
        :vendor="vendor"
        :messages="messages"
        class="item-right"
      ></Description>
    </div>

    <div class="column">
      <img
        class="item-right"
        style="height: 200px"
        :src="getImageUrl(image)"
        alt="Image"
      />
    </div>
  </div>
</template>

<script>
import Description from "@/components/Description";
export default {
  name: "SingleSolution",
  props: ["isLeft", "image", "title", "vendor", "messages"],
  components: { Description },
  methods: {
    getImageUrl(filename) {
      return require(`../assets/${filename}`);
    },
  },
};
</script>

<style scoped>
.item {
  margin-top: 5rem;
}
</style>
